import type { RebaseContext } from "@rebasepro/cms-types";
import type { CollectionConfig } from "@rebasepro/types";
import playersCollection from "./collections/players";

// A friends account ("u:<uid>", as the friend tables store it) as a person: the name they gave, from People
// (songbuzz_friend_person). For the admin panel's titles, so a friendship reads "Ana & Leo", not two ids.
export async function personName(context: RebaseContext, who: unknown): Promise<string> {
    const id = String(who ?? "");
    if (!id) return "?";
    const person = await context.client.data.collection<{ name?: string | null }>("players").findById(id).catch(() => undefined);
    const name = person?.name;
    return typeof name === "string" && name ? name : id;
}

// The player a column names ("u:<uid>" or a Solo device id, as Players keys them), shown as their card in the admin
// instead of the id. A join, not a column: nothing is stored, and an id Players doesn't know yet shows no card.
export const playerOf = (name: string, column: string, relationName: string) => ({
    name,
    type: "relation" as const,
    relation: {
        kind: "via" as const, cardinality: "one" as const, target: (): CollectionConfig => playersCollection, relationName,
        joinPath: [{ table: "songbuzz_players", on: { from: column, to: "id" } }],
    },
    admin: { readOnly: true },
});
